// libs
import { styled } from '@nykaa/ui-components';

// components
import BaseButton from 'shared/components/Button';

export const Container = styled.form`
  .nd-container {
    display: flex;
  }

  .nd-email {
    height: 48px;
    border: 0.5px solid ${({ theme }) => theme.colors.surfaceInverse};
    ${({ theme }) => theme.typography.bodyLarge};
    padding: ${({ theme }) => `0 ${theme.spacing.spacing80}`};
    border-radius: ${({ theme }) => theme.borders.radiusNone};

    &:focus {
      outline: 0;
    }

    &:-webkit-autofill {
      -webkit-text-fill-color: inherit !important;
      -webkit-box-shadow: 0 0 0px 1000px white inset;
    }
  }

  .nd-text {
    width: 100%;
    ${({ theme }) => theme.typography.bodyMedium};
    color: ${({ theme }) => theme.colors.textSecondary};
    margin-top: ${({ theme }) => theme.spacing.spacing60};
  }
`;

export const Button = styled(BaseButton)`
  width: 140px;
  height: 48px;
  ${({ theme }) => theme.typography.subTitleLarge};
  border-radius: ${({ theme }) => theme.borders.radiusNone};

  &:not([disabled]):hover,
  &:hover {
    background: #000;
  }
`;
